
const ApiUriPrefix = "../../../../../../../api/";

const ApiUriPrefix_v1 = "../../../../../../../api/1/";

export {
    ApiUriPrefix,
    ApiUriPrefix_v1
}